<template>
  <div class="flex-a justify-between w-full h-10">
    <Button
      :path="pager.prev"
      icon="ChevronIcon"
      iconsize="23px"
      :iconcolor="color"
      :text="prevText"
      :tabindex="pager.isFirst ? -1 : 0"
      :textcolor="color"
      :iconleft="true"
      aria="Previous item"
      iconrotation=""
      data-gtm-content-pager
      class="flex-c h-10 w-auto flex-none focus-a"
      :class="{ 'opacity-50': pager.isFirst }"
    />
    <span
      v-if="title"
      class="block text-white font-serif whitespace-no-wrap overflow-hidden truncate"
      v-html="title"
    />
    <Button
      :path="pager.next"
      icon="ChevronIcon"
      iconsize="23px"
      :iconcolor="color"
      :text="nextText"
      :tabindex="pager.isLast ? -1 : 0"
      :textcolor="color"
      :iconright="true"
      data-gtm-content-pager
      aria="Next item"
      iconrotation="rotate-180"
      class="flex-c h-10 w-auto flex-none focus-a"
      :class="{ 'opacity-50': pager.isLast }"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '@/components/buttons/Button.vue'

export default {
  name: 'Pager',

  components: {
    Button
  },

  props: {
    tourGroup: {
      type: Array,
      default: () => []
    },

    color: {
      type: String,
      default: 'white'
    },

    title: {
      type: String,
      default: ''
    },

    prevText: {
      type: String,
      default: ''
    },

    nextText: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters([]),

    pager() {
      const tourGroup = this.tourGroup

      const tourGroupLength = tourGroup.length

      const tourGroupSlugs = tourGroup.map(({ slug }) => slug)

      const currentItem = this.$route.params.media_id

      const currentIndex = tourGroupSlugs.indexOf(currentItem)

      const prev =
        currentIndex > 0
          ? tourGroupSlugs[currentIndex - 1]
          : tourGroupSlugs[tourGroupLength - 1]

      const next =
        currentIndex < tourGroupLength - 1
          ? tourGroupSlugs[currentIndex + 1]
          : tourGroupSlugs[0]

      const isFirst = currentIndex === 0
      const isLast = currentIndex === tourGroupLength - 1

      return {
        prev,
        next,
        currentIndex,
        currentItem,
        tourGroupSlugs,
        isLast,
        isFirst
      }
    }
  }
}
</script>
